import styled from 'styled-components';
import { memo } from 'react';

const TableEmptyBlock = styled.div`
    font-size: 12px;
    color: #999;
    padding: 50px 0;
    background-color: #fbfbfc;
    text-align: center;
`

const TableEmpty = ({ text, className=''}: { text: string, className? : string }) => {
  return (
    <TableEmptyBlock className={'comm-nodata-area ' + className}>
      {text}
    </TableEmptyBlock>
  )
}

export default memo(TableEmpty);